import React from 'react';
import { LANGUAGES } from './constants';

const LanguageSelector = ({ lang, setLang }) => (
    <div className="language-selector">
        {LANGUAGES.map(language => (
            <button
                key={language.code}
                className={`lang-circle ${lang === language.code ? 'active' : ''}`}
                onClick={() => setLang(language.code)}
            >
                {language.label}
            </button>
        ))}
    </div>
);

export default LanguageSelector; 